<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="orange">
          <v-toolbar-title>Connection Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="settings-container">
          <!-- INSERT CONTENT HERE -->
          <v-form class="settings-form">
            <v-text-field
              v-model="settings.server_address"
              label="Server Address"
              placeholder="https://server.address"
              required
            ></v-text-field>
            <v-text-field
              v-model="settings.server_port"
              label="Server Port"
              placeholder="80 or 443"
              required
            ></v-text-field>
            <v-text-field
              v-model="settings.server_path"
              label="Server Path"
              placeholder="/cash/"
              required
            ></v-text-field>
            <v-text-field v-model="settings.client_id" label="Client ID" required></v-text-field>
            <v-btn @click="saveAndExit">Save</v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AppSettings from "../services/appSettingsManager";

export default {
  mounted() {},
  data() {
    return {
      dialog: false,
      settings: {
        server_address: null,
        server_port: null,
        server_path: null,
        client_id: null,
      },
    };
  },
  methods: {
    readValueForCID(cid) {
      return parseInt(cid) ? parseInt(cid) + 1238476523 - 383675 : "";
    },

    writeValueForCID(cid) {
      return parseInt(cid) ? parseInt(cid) - 1238476523 + 383675 : "";
    },

    popup() {
      console.log("popping up now");
      let curSettings = AppSettings.getConnectionSettings();
      console.log("STORED CONNECTION SETTINGS:", curSettings);
      if (curSettings) {
        this.settings.server_address = curSettings.server_address ?? "";
        this.settings.server_port = curSettings.server_port ?? "";
        this.settings.server_path = curSettings.server_path ?? "";
        this.settings.client_id = this.readValueForCID(curSettings.client_id ?? "");
      }

      this.dialog = true;
    },
    saveAndExit() {
      // DO STUFF
      this.settings.client_id = this.writeValueForCID(this.settings.client_id);
      AppSettings.setConnectionSettings(this.settings);
      //NOW CLOSE
      this.dialog = false;
    },
  },
  props: {},
};
</script>

<style lang="css" scoped>
.settings-container {
  width: 100%;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-form {
  min-width: 50vw;
  text-align: center;
}
</style>
